// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3adL7","title":"Images90_title__21fuK","images":"Images90_images__3jHO4"};